import { createExcelAndDownload } from '../../../../utils/reportExcelExport';

export function Report(vouchers) {
    const customHeadings = [
        { key: "invoice_no", label: "Voucher No" },
        { key: "member_id.member_id", label: "Member ID" },
        { key: "member_id.name", label: "Member Name" },
        { key: "voucher_date", label: "Issue Date", isDate: true },
        { key: "invoice.due_date", label: "Due Date", isDate: true },
        { key: "invoice.total_amount", label: "Due Amount" },
        { key: "invoice.discount", label: "Discount" },
        { key: "reference_number", label: "Payment Reference" },
        { key: "invoice.payment_status", label: "Status" },
    ];
    createExcelAndDownload("Expected Income Report", vouchers, customHeadings);
}
